import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { motion } from "framer-motion";

import "react-vertical-timeline-component/style.min.css";
import { useTranslation } from "react-i18next";

import { styles } from "../styles";
import { experiences } from "../constants";
import { SectionWrapper } from "../hoc";
import { textVariant } from "../utils/motion";

const ExperienceCard = ({ experience, t }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        background: "rgba(245, 245, 245, 0.9)", // Fondo claro para las cards
        backdropFilter: "blur(8px)", // Efecto desenfoque
        border: "1px solid rgba(200, 200, 200, 0.5)", // Borde sutil para las cards
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)", // Sombra suave
        color: "#333", // Texto oscuro para buen contraste
      }}
      contentArrowStyle={{ borderRight: "7px solid rgba(245, 245, 245, 0.9)" }}
      date={t(experience.date)} // Traduciendo la fecha/descripción
      iconStyle={{
        background: "rgba(200, 200, 255, 0.9)", // Fondo suave y pastel para los íconos
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Sombra para los íconos
      }}
      icon={
        <div className="flex justify-center items-center w-full h-full">
          <img
            src={experience.icon}
            alt={t(experience.company_name)}
            className="w-[60%] h-[60%] object-contain"
          />
        </div>
      }
    >
      <div>
        <h3 className="text-black text-[24px] font-bold">
          {t(experience.title)} {/* Traduciendo el título */}
        </h3>
        <p
          className="text-gray-700 text-[16px] font-semibold"
          style={{ margin: 0 }}
        >
          {t(experience.company_name)} {/* Traduciendo el nombre de la compañía */}
        </p>
      </div>

      <ul className="mt-5 list-disc ml-5 space-y-2">
        {experience.points.map((point, index) => (
          <li
            key={`experience-point-${index}`}
            className="text-gray-800 text-[14px] pl-1 tracking-wider"
          >
            {t(point)} {/* Traduciendo cada punto */}
          </li>
        ))}
      </ul>
    </VerticalTimelineElement>
  );
};

const Experiences = () => {
  const { t } = useTranslation(); // Hook de traducción

  return (
    <>
      <motion.div variants={textVariant()}>
        <h1 className={`${styles.heroHeadText} text-center text-black`}>
          {t("experiences.title")}
        </h1>
      </motion.div>

      <div className="mt-20 flex flex-col">
        <VerticalTimeline>
          {experiences.map((experience, index) => (
            <ExperienceCard key={`experience-${index}`} experience={experience} t={t} />
          ))}
        </VerticalTimeline>
      </div>
    </>
  );
};

export default SectionWrapper(Experiences, "work");
